import React from 'react';

export default function AppFooter() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="AppFooter">
      <div className="AppContainer">
        <small>&copy; {currentYear} Busable LMS. All rights reserved.</small>
      </div>
    </footer>
  )
}
